import * as icons from '../../assets/icons'
import { Box, Image, Text, TextStyleProps } from '@dtx-company/shared-components/src'
import React from 'react'

interface FinishStepProps {
  hasCovid: boolean
}

const getDateText = (): string =>
  new Date().toLocaleString('en-us', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })

const EmphasisText: React.FC<TextStyleProps> = ({ children, ...rest }) => (
  <Text variant="body/large" fontWeight={600} {...rest}>
    {children}
  </Text>
)

const Approved: React.FC = () => (
  <>
    <Text variant="body/large" as="div" textAlign="center" mb="24px">
      Check-In Status: <EmphasisText color="masterWeb.green4">Approved</EmphasisText>
    </Text>
    <Image src={icons.checkInAllowed} mb="24px" />
    <EmphasisText color="masterWeb.green4" mb="8px">
      Okay to proceed.
    </EmphasisText>
    <Text variant="body/medium" mb="12px" fontWeight={600}>
      Valid: {getDateText()}
    </Text>
    <Text variant="body/small" color="primary.grey" textAlign="center">
      Please show this screen to the security at the facility entrance. Thank you for helping us
      protect you and others during this time.
    </Text>
  </>
)

const Denied: React.FC = () => (
  <>
    <Text variant="body/large" as="div" textAlign="center" mb="24px">
      Check-In Status: <EmphasisText color="status.errorDark">Not Approved</EmphasisText>
    </Text>
    <Image src={icons.checkInDenied} mb="24px" />
    <EmphasisText color="status.errorDark" mb="8px">
      Do not proceed.
    </EmphasisText>
    <Text variant="body/medium" mb="16px" fontWeight={600}>
      Valid: {getDateText()}
    </Text>
    <Text variant="body/small" color="primary.grey" textAlign="center">
      <Text
        as="a"
        variant="body/small"
        fontWeight={600}
        color="primary.flowBlue"
        href="https://www.cdc.gov/screening/further-instructions.html"
      >
        Click here
      </Text>{' '}
      for further instructions. Thank you for helping us protect you and others during this time.
    </Text>
  </>
)

const FinishStep: React.FC<FinishStepProps> = ({ hasCovid }) => {
  return (
    <Box flexDirection="column" alignItems="center" justifyContent="center" pt="48px">
      {hasCovid ? <Denied /> : <Approved />}
    </Box>
  )
}

export default FinishStep
